<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.year(v-if='!loading')
      .grid
        .col-3.titles
          router-link(:to={path: '/exhibitions'})
            h1.h-l
              | exhibitions
          h4.h-sm.status
            | {{ $route.params.year }}
        .col-9_xs-12
          .grid.no-margin(v-if="exhibitions.length > 0")
            .col-6_xs-12(v-for="exhibition in exhibitions")
              router-link(:to="{path: year(exhibition.content.start_date) + '/' + exhibition.uid}")
                .screen-small
                  img.cover(:src="exhibition.image" :alt="exhibition.content.title")
                  .captions
                    h2.title.h-l.italic
                      | {{ exhibition.content.title }}
                    h2.dates.h-sm
                      | {{ displayDate(exhibition) }}
          .grid.no-margin(v-else)
            .col-9_xs-12
              h2.standin
                | Traveling exhibitions coming soon ...
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import dateFormat from 'dateformat'

export default {
  name: 'exhibitions-traveling',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: [],
      // url: 'http://localhost:8888/caam/caam_live/api/exhibitions-traveling/'
      url: 'https://caamuseum.org/api/exhibitions-traveling/'
    }
  },

  created () {
    this.key = 'traveling'
    this.getData()
  },

  methods: {
    getData: function () {
      this.loading = true
      this.get(this.url, response => {
        this.loading = false
        this.loadedData = response.data
      })
    },

    hero: function (image, files) {
      return files.find(item => item.filename === image)
    },

    startDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d')
      } else {
        return ''
      }
    },

    endDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d, yyyy')
      } else {
        return ''
      }
    },

    /* eslint-disable */
    displayDate: function (exhibition) {
      const dd = exhibition.content.display_date
      console.log(dd)
      const date = exhibition.content.start_date + ' - ' + exhibition.content.end_date
      return !!dd ? dd : date
    },
    /* eslint-enable */

    year: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'yyyy')
      } else {
        return ''
      }
    }
  },

  computed: {
    exhibitions: function () {
      return this.loadedData[this.key]
    },

    parameter: function () {
      return this.$route.params.year
    }
  }
}
</script>

<style lang="sass">
@import '../styles/_variables'
@import '../styles/_mixins'
.content
  margin-top: $paddingTop
  @include respond-to(xs)
    margin-top: 1rem
  &.year
    .titles
      h1, h4
        padding-left: 0
    .status
      color: $exhibitions
  .standin
    margin-top: $paddingTop
</style>



// WEBPACK FOOTER //
// ExhibitionsTraveling.vue?754cf9aa